/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AddJobLinkedItemModal_job$ref = any;
type AddUpdateJobLinkedItemModal_job$ref = any;
type JobLinkedItemsTable_jobLinkedItemEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobLinkedItems_job$ref: FragmentReference;
declare export opaque type JobLinkedItems_job$fragmentType: JobLinkedItems_job$ref;
export type JobLinkedItems_job = {|
  +id: string,
  +linkedItems: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +partNumber: ?string,
      |},
      +$fragmentRefs: JobLinkedItemsTable_jobLinkedItemEdges$ref,
    |}>
  |},
  +$fragmentRefs: AddJobLinkedItemModal_job$ref & AddUpdateJobLinkedItemModal_job$ref,
  +$refType: JobLinkedItems_job$ref,
|};
export type JobLinkedItems_job$data = JobLinkedItems_job;
export type JobLinkedItems_job$key = {
  +$data?: JobLinkedItems_job$data,
  +$fragmentRefs: JobLinkedItems_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobLinkedItems_job",
  "type": "Job",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "linkedItems"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "linkedItems",
      "name": "__Job_linkedItems_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "JobLinkedItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "JobLinkedItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "partNumber",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "JobLinkedItemsTable_jobLinkedItemEdges",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "AddJobLinkedItemModal_job",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AddUpdateJobLinkedItemModal_job",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b8ec38e23debe57743da6a9d8ad8980a';
module.exports = node;
